import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {ToggleButton, ToggleButtonGroup} from "@material-ui/lab";
import BlurOnIcon from '@material-ui/icons/BlurOn'
import AdjustIcon from '@material-ui/icons/Adjust'
import ThreeDRotationIcon from '@material-ui/icons/ThreeDRotation'
import CameraEnhanceIcon from '@material-ui/icons/CameraEnhance'
import SwapHorizIcon from '@material-ui/icons/SwapHoriz'
import InvertColorsIcon from '@material-ui/icons/InvertColors'
import NGLContext from '../../NGLContext'
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import {Slider} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import PhotoOutlinedIcon from '@material-ui/icons/PhotoOutlined';
import {download} from 'ngl';


const ITEM_HEIGHT = 48;
const styles = theme => ({
    root: {
        position: 'absolute',
        top: '0.5rem',
        right: '0.5rem',
        zIndex: theme.zIndex.appBar,
    },
    button: {
        outline: 'none !important',
    },
    popover: {
        width: 250,
        padding: theme.spacing(2),
    }
});

const cameraTypes = [
    "perspective",
    "orthographic"
];

@withStyles(styles)
class ToggleBar extends Component {

    static propTypes = {
        classes: PropTypes.object.isRequired,
        stage: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.handleCamera = this.handleCamera.bind(this);
        this.handleCameraTypeOpen = this.handleCameraTypeOpen.bind(this);
        this.handleCameraTypeClose = this.handleCameraTypeClose.bind(this);
        this.handleCameraTypeChange = this.handleCameraTypeChange.bind(this);
        this.handleCameraFocusOpen = this.handleCameraFocusOpen.bind(this);
        this.handleCameraFocusClose = this.handleCameraFocusClose.bind(this);
        this.handleCameraFocusChange = this.handleCameraFocusChange.bind(this);
        this.handleCameraFocusCommit = this.handleCameraFocusCommit.bind(this);
    }

    state = {
        cameraOptions: [],
        cameraType: "perspective",
        cameraTypeMenu: null,
        cameraSettingsPopover: null,
        focus: 0,
    };

    handleCameraTypeOpen = event => {
        this.setState({cameraTypeMenu: event.currentTarget})
    };

    handleCameraFocusOpen = event => {
        this.setState({cameraSettingsPopover: event.currentTarget});
    };

    handleCameraTypeClose = () => {
        this.setState({cameraTypeMenu: null})
    };

    handleCameraFocusClose = () => {
        this.setState({cameraSettingsPopover: null})
    };

    handleCameraFocusChange = (event, value) => {
        this.props.stage.setFocus(value);
    };

    handleCameraFocusCommit = (event, value) => {
        this.setState({"focus": value});
    };

    handleCameraTypeChange = (event, index) => {
        // TODO: Use this function as a template to change a stage parameter
        this.setState({"cameraType": cameraTypes[index]},
            () => {
                this.props.stage.setParameters({
                        "cameraType": cameraTypes[index]
                    }
                );
            });
    };

    // TODO use prevstate for default switch
    handleCamera = (event, cameraOptions) => {
        var oldCameraOptions = this.state.cameraOptions;
        let addedOption = oldCameraOptions ? cameraOptions.filter(x => !oldCameraOptions.includes(x)) : cameraOptions;
        let removedOption = cameraOptions && oldCameraOptions ? oldCameraOptions.filter(x => !cameraOptions.includes(x)) : null;
        const resetCamera = (removedOption) => {
            if (removedOption === 'rock') {
                this.props.stage.setRock(false);
            } else if (removedOption === 'spin') {
                this.props.stage.setSpin(false);
            } else if (removedOption === 'colors') {
                this.props.stage.setParameters({backgroundColor: 'white'});
            }
        };

        this.setState({cameraOptions}, () => {
                console.log(addedOption);
                switch (addedOption.toString()) {
                    case 'adjust':
                        // resetCamera(oldCameraOptions, this.state);
                        console.log("Center selection");
                        this.props.stage.autoView(1000);
                        // Remove adjust whithin cameraOption array to have a
                        // behaviour similar to a button
                        this.setState({cameraOptions: cameraOptions.filter(item => item !== 'adjust')});
                        break;
                    case 'rock':
                        // resetCamera(prevState, this.state);
                        // resetCamera(oldCameraOptions, this.state);
                        console.log("Rock stage");
                        this.props.stage.setRock(true);
                        break;
                    case 'spin':
                        // resetCamera(oldCameraOptions, this.state);
                        // resetCamera(prevState, this.state);
                        console.log("Spin stage");
                        this.props.stage.setSpin(true);
                        break;
                    case 'colors':
                        // resetCamera(oldCameraOptions, this.state);
                        // resetCamera(prevState, this.state);
                        console.log("Spin stage");
                        this.props.stage.setParameters({backgroundColor: 'black'});
                        break;
                    case 'screenshot':
                        this.props.stage.makeImage({
                            factor: 1,
                            antialias: false,
                            trim: false,
                            transparent: false
                        }).then(function (blob) {
                            download(blob, "ariaweb-screenshot.png")
                        });
                    default:
                        resetCamera(removedOption.toString());
                        console.log("Reset camera moves");
                }
            }
        );
    };

    render() {
        const {classes} = this.props;
        const popoverId = this.state.cameraSettingsPopover ? 'camera-popover' : undefined;
        return (
            <React.Fragment>
                <ToggleButtonGroup
                    size="small"
                    value={this.state.cameraOptions}
                    className={classes.root}
                    onChange={this.handleCamera}>
                    <Tooltip title="Center">
                        <ToggleButton value="adjust"
                                      className={classes.button}>
                            <AdjustIcon/>
                        </ToggleButton>
                    </Tooltip>
                    <Tooltip title="Rock">
                        <ToggleButton value="rock"
                                      className={classes.button}>
                            <SwapHorizIcon/>
                        </ToggleButton>
                    </Tooltip>
                    <Tooltip title="Spin">
                        <ToggleButton value="spin"
                                      className={classes.button}>
                            <ThreeDRotationIcon/>
                        </ToggleButton>
                    </Tooltip>
                    <Tooltip title="Background color">
                        <ToggleButton value="colors"
                                      className={classes.button}>
                            <InvertColorsIcon/>
                        </ToggleButton>
                    </Tooltip>
                    <Tooltip title="Camera type">
                        <ToggleButton
                            value="camera"
                            aria-controls="camera-type-menu"
                            aria-haspopup="true"
                            onClick={this.handleCameraTypeOpen}
                            className={classes.button}
                        >
                            <CameraEnhanceIcon/>
                        </ToggleButton>
                    </Tooltip>
                    <Tooltip title="Focus">
                        <ToggleButton
                            value="focus"
                            aria-describedby={popoverId}
                            variant="contained"
                            onClick={this.handleCameraFocusOpen}
                            className={classes.button}
                        >
                            <BlurOnIcon/>
                        </ToggleButton>
                    </Tooltip>
                    <Tooltip title="Screenshot">
                        <ToggleButton
                            value="screenshot"
                            aria-describedby={popoverId}
                            variant="contained"
                            className={classes.button}
                        >
                            <PhotoOutlinedIcon/>
                        </ToggleButton>
                    </Tooltip>
                </ToggleButtonGroup>
                <Menu
                    id="camera-type-menu"
                    anchorEl={this.state.cameraTypeMenu}
                    keepMounted
                    open={Boolean(this.state.cameraTypeMenu)}
                    // onChange={this.handleCameraTypeChange}
                    onClose={this.handleCameraTypeClose}
                    MenuListProps={{
                        name: 'cameraType'
                    }}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    {cameraTypes.map((option, index) => (
                        <MenuItem
                            onClick={e => this.handleCameraTypeChange(e, index)}
                            key={option}
                        >{option.charAt(0).toUpperCase() +
                        option.slice(1)}</MenuItem>
                    ))}
                </Menu>
                <Popover
                    id={popoverId}
                    open={Boolean(this.state.cameraSettingsPopover)}
                    anchorEl={this.state.cameraSettingsPopover}
                    onClose={this.handleCameraFocusClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    <div className={classes.popover}>
                        <Slider
                            defaultValue={this.state.focus}
                            step={1}
                            min={0}
                            max={100}
                            valueLabelDisplay="off"
                            onChange={this.handleCameraFocusChange}
                            onChangeCommitted={this.handleCameraFocusCommit}
                        />
                    </div>
                </Popover>
            </React.Fragment>
        );
    }
}

export default ToggleBar;